// extracted by mini-css-extract-plugin
module.exports = {"selectbox":"daterangepicker_selectbox__3XnAX"};